import React, { useState } from 'react'
import PropTypes from 'prop-types'

const icons = {
  ArrowRight: (fill, stroke, strokeCircle) => (
    <svg xmlns="http://www.w3.org/2000/svg" width="58" height="58" viewBox="0 0 58 58" fill={fill}>
      <path
        d="M29 57C44.464 57 57 44.464 57 29C57 13.536 44.464 1 29 1C13.536 1 1 13.536 1 29C1 44.464 13.536 57 29 57Z"
        stroke={strokeCircle}
        strokeMiterlimit="10"
      />
      <path
        d="M29 19.2715L38.729 29.0005L29 38.7295"
        stroke={stroke}
        strokeWidth="2"
        strokeMiterlimit="10"
      />
      <path d="M19.2695 29H38.7285" stroke={stroke} strokeWidth="2" strokeMiterlimit="10" />
    </svg>
  ),
  ArrowLeft: (fill, stroke, strokeCircle) => (
    <svg xmlns="http://www.w3.org/2000/svg" width="58" height="58" viewBox="0 0 58 58" fill={fill}>
      <path
        d="M29 57C44.464 57 57 44.464 57 29C57 13.536 44.464 1 29 1C13.536 1 1 13.536 1 29C1 44.464 13.536 57 29 57Z"
        stroke={strokeCircle}
        strokeMiterlimit="10"
      />
      <path
        d="M28.9985 38.7295L19.2695 29.0005L28.9985 19.2715"
        stroke={stroke}
        strokeWidth="2"
        strokeMiterlimit="10"
      />
      <path d="M38.7285 29H19.2695" stroke={stroke} strokeWidth="2" strokeMiterlimit="10" />
    </svg>
  ),
}

const Icon = ({ name, width, height, fill, stroke, strokeCircle, strokeOnHover }) => {
  const [isHovered, setIsHovered] = useState(false)

  const handleMouseEnter = () => setIsHovered(true)
  const handleMouseLeave = () => setIsHovered(false)

  const icon = icons[name]
  if (!icon) return null

  const iconFill = isHovered ? stroke : fill
  const iconStroke = isHovered ? strokeOnHover : stroke

  return (
    <div
      style={{
        width,
        height,
      }}
      onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseLeave}
    >
      {icon(iconFill, iconStroke, strokeCircle)}
    </div>
  )
}

Icon.propTypes = {
  name: PropTypes.oneOf(['ArrowRight', 'ArrowLeft']).isRequired,
  width: PropTypes.string,
  height: PropTypes.string,
  fill: PropTypes.string,
  stroke: PropTypes.string,
  strokeCircle: PropTypes.string,
}

export default Icon
